module.exports = __webpack_public_path__ + "static/media/C2-CodePen.0af8dded.svg";